import { isAxiosError } from 'axios';
import { ErrorResponse } from '~/infra/ErrorResponse';
export const classifyBootOutcome = (error)=>{
    if (isAxiosError(error) && error.response == null) return 'networkError';
    if (new ErrorResponse(error).status === 401) return 'sessionExpired';
    return 'serverError';
};
